import request from './backend.request.util';

export { request };

export default {
  request
}